var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content", on: { scroll: _vm.handleScroll } },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "navlist" },
        _vm._l(_vm.navlist, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "nav-item",
              class: [
                "nav-item",
                _vm.activeStep == index ? "currentTab" : "tab"
              ],
              on: {
                click: function($event) {
                  return _vm.jump(index)
                }
              }
            },
            [_vm._v("\n          " + _vm._s(item.name) + "\n      ")]
          )
        }),
        0
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d4103b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d4103b4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXDetail/EXNavList.vue
// module id = 379
// module chunks = 0